export default __webpack_public_path__ + "assets/img/juara2.efc3cf749c50f243e397760c2811f34a.png";